export default __webpack_public_path__ + "static/bullet_header-7299b10fe4a254288c216f62273fe8c2.png";